module.exports = __webpack_public_path__ + "img/jake-coding.15a53294.jpg";